import React from "react";
import "./OfferBg.css";
import Fade from "react-reveal/Fade";

const OfferBg = () => {
  return (
    <div className="w-100 mx-auto py-5">
      <div className="container w-100">
        <div className="offer_bg">
          <div className="offer_main">
            <div>
              <div className="offer_bg_text text-center">
                <Fade left duration={1000}>
                  <h1 className="mb-0">Buy Less, Access More, Live Lighter</h1>
                </Fade>
                <Fade left duration={1300}>
                  <h1 className="offer_bg_text">
                    <span>
                      We Share a{" "}
                      <span className=" fw-bolder" style={{ fontWeight: 900 }}>
                        Green and Sustainable Lifestyle!
                      </span>
                    </span>
                  </h1>
                </Fade>
                <Fade left duration={1500}>
                  <div className="charity">
                    <p className="text-canter fw-bold card-text text-white">
                      10% of our profit goes to charity Your business will make
                      a difference!
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferBg;
